/*
 * The token of the session, read by the request interceptor at the
 * moment a request goes out (see client.ts).
 *
 * It is kept here rather than written into `apiClient.defaults`, and
 * the providers set it while they render rather than from an effect.
 * React runs the effects of the children before those of their parent:
 * a component mounting in the same commit in which the session becomes
 * ready — the sidebar's partner selector, which is not lazy-loaded —
 * fired its first request before an effect in the provider above could
 * have put the token anywhere. That request went out with no
 * Authorization header at all and came back 401.
 */
let currentToken: string | null = null;

export const setAuthToken = (token: string | null | undefined): void => {
  currentToken = token || null;
};

export const authorizationHeader = (): string | null =>
  currentToken ? `Bearer ${currentToken}` : null;
